import { ConfirmModal, ConfirmModalProps } from '@features/ui-layout/components/Modal/ConfirmModal';

export const modalsList = { confirm: (params: ConfirmModalProps) => <ConfirmModal {...params} /> } as const;

export type ModalName = keyof typeof modalsList;
